// Import vendors ----------------------------------------------------------------------------------
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
// Export packages ---------------------------------------------------------------------------------
export { provide } from '@vue/composition-api';
// -------------------------------------------------------------------------------------------------

// Inject plugin
Vue.use(VueCompositionAPI);
